const legacyApps = ['activecampaign', 'icontact', 'whmcs'];

const isLegacyApplication = (appId?: string): boolean => {
  if (!appId) return false;
  return legacyApps.includes(appId);
};

export { isLegacyApplication };
